import { create } from "zustand";

import { COUNTDOWN_INITIAL_SECONDS } from "../api/constants";

type UpsellState = {
  timeLeft: number;
  isModalOpen: boolean;
  isModalProgressAnimated: boolean;
  tickCountdown: () => void;
  setModalOpen: (isOpen: boolean) => void;
  setModalProgressAnimated: (isAnimated: boolean) => void;
};

export const useUpsellStore = create<UpsellState>((set) => ({
  timeLeft: COUNTDOWN_INITIAL_SECONDS,
  isModalOpen: false,
  isModalProgressAnimated: false,
  tickCountdown: () =>
    set((state) => ({ timeLeft: Math.max(0, state.timeLeft - 1) })),
  setModalOpen: (isModalOpen) => set({ isModalOpen }),
  setModalProgressAnimated: (isModalProgressAnimated) =>
    set({ isModalProgressAnimated }),
}));
